/**
 * Text read off a supplier's PDF, kept as printed, with its English
 * translation on the line underneath.
 *
 * Chris 2026-10-19 (Gritt's German invoices): "keep the German, with an
 * English translation underneath". The reading puts the translation in
 * separate *_en fields; this is the one place they are joined for the form.
 */
export const withEnglishUnderneath = (original, english) => {
  const printed = (original || '').trim();
  const en = (english || '').trim();
  if (!en || en.toLowerCase() === printed.toLowerCase()) return original || '';
  if (!printed) return `EN: ${en}`;
  return `${printed}\nEN: ${en}`;
};
